import express, { Router } from 'express';

import * as invoiceValidation from '@/modules/invoice/invoice.validation';
import * as invoiceController from '@/modules/invoice/invoice.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.READ),
    validateMiddleware(invoiceValidation.getInvoices),
    invoiceController.getInvoices,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.CREATE),
    validateMiddleware(invoiceValidation.createInvoice()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'company' }),
    invoiceController.createInvoice,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.READ),
    validateMiddleware(invoiceValidation.getInvoiceById),
    invoiceController.getInvoiceById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.UPDATE),
    validateMiddleware(invoiceValidation.updateInvoice()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    invoiceController.updateInvoice,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.DELETE),
    validateMiddleware(invoiceValidation.deleteInvoiceById),
    invoiceController.deleteInvoiceById,
  );

export default router;
